import * as React from 'react';

import SignMe32 from './SignMe32';

export const signMe32 = () => <SignMe32 />;

export default {
    title: 'Icon/Fill/SignMe32',
    component: SignMe32,
    parameters: {
        notes: "`import SignMe32 from 'box-ui-elements/es/icon/fill/SignMe32';`",
    },
};
